import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef } from "vue"

import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import DateHelper from "~/ts/library/Date";
import {ref} from "vue";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import {__} from "~/ts/library/Translate";
import MyDateTimePicker from "~/core-ui/vue/ui/MyDateTimePicker.vue";
import DateTimeInputControls from "~/operatorApplication/vue/misc/DateTimeInputControls.vue";



const __default__ = {
    name: "OperatorApplicationSendDelayedMessageDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    site: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["input"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;


let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");

let model = ref<{
    dateTime: string
}>();


let date = new Date();
date.setHours(date.getHours() + 1);
date.setMinutes(0);
date.setSeconds(0);

function applyDate(date: Date) {
    model.value = {
        dateTime: (new DateHelper(date)).toMysqlFormat()
    }
}

applyDate(date);

async function send() {
    emits("input", Math.ceil((new DateHelper(model.value.dateTime)).dateObject.getTime() / 1000));
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(MyDialog, {
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(__)('Отправить позже'),
    form: {
            model: _unref(model)
        },
    "button-text": _unref(__)('Создать'),
    onApply: send
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _unref(__)('Дата'),
        rules: _unref(requiredRule),
        prop: "dateTime"
      }, {
        default: _withCtx(() => [
          _createVNode(MyDateTimePicker, {
            modelValue: _unref(model).dateTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).dateTime) = $event)),
            format: "DD.MM.YYYY HH:mm"
          }, null, 8, ["modelValue"]),
          (__props.site)
            ? (_openBlock(), _createBlock(DateTimeInputControls, {
                key: 0,
                modelValue: _unref(model).dateTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).dateTime) = $event)),
                site: __props.site
              }, null, 8, ["modelValue", "site"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "form", "button-text"]))
}
}

})